import { SimpleOrder } from '@model/simpleOrder';
import { TypeOrderEnum } from './../../model/enum/type-order.enum';
import { Injectable } from '@angular/core';
import { map, Subject } from 'rxjs';
import { SocketService } from '@services/webFeeder/socket.service';
import { ConfigService } from '@services/webFeeder/config.service';
import { MessageParameterNegotiation } from '@model/webFeeder/message-parameter-negotiation.model';
import { MessageWebFeeder } from '@model/webFeeder/message-web-feeder.model';
import { MessageDailyOrder } from '@model/webFeeder/daily-message.model';
import { Observable, BehaviorSubject , of } from 'rxjs';
import { Constants } from '@utils/constants';
import { AuthServer } from '@services/auth-server.service';
import { SideEnum } from '@model/enum/side.enum';
import { CancelOrder } from '@model/webFeeder/message-cancel-order';
import { MarketTypeEnum } from '@model/enum/market-type.enum';
import { AppUtils } from '@utils/app.utils';
import { MarketEnum } from '@model/enum/market.enum';
import { MatDialog } from '@angular/material/dialog';
import { EletronicSignatureModalComponent } from '@component/eletronic-signature-modal/eletronic-signature-modal.component';
import { TermOperatorModalComponent } from '@component/term-operator-modal/term-operator-modal.component';
import { BilletOrderTypeEnum } from '@model/enum/billet-order-type';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment';
import { TypeOrderRequestEnum } from '@model/enum/type-order-send.enum';

@Injectable({
  providedIn: 'root'
})
export class DailyOrderService {

  messagesDailyOrder: Observable<MessageDailyOrder[]>;
  dialog: MatDialog;
  private serviceSubject = new Subject<MessageEvent>();
  private activeSubscriptions = 0;
  private tempOrders = [];
  private subscribeComponent = [];

  public _cancelOrderConfirmation = new BehaviorSubject<boolean>(false);
  public cancelOrderConfirmation$ = this._cancelOrderConfirmation.asObservable();

  public _reSendOrderConfirmation = new BehaviorSubject<boolean>(false);
  public editOrderConfirmation$ = this._reSendOrderConfirmation.asObservable();

  public _showHiddenPadOrderConfirmation = new BehaviorSubject<boolean>(false);
  public showHiddenPadOrderConfirmation$ = this._showHiddenPadOrderConfirmation.asObservable();

  public _orderSentSuccess = new Subject<boolean>();
  public orderSentSuccess$ = this._orderSentSuccess.asObservable();

  constructor(
    private socketService: SocketService,
    private configService: ConfigService,
    private authServer: AuthServer,
    private _datePipe: DatePipe,
    _dialog: MatDialog,
  ) {
    this.dialog = _dialog;
  }

  createSubject() {
    const newService = {
      name: 'dailyOrder',
      serviceSubject: this.serviceSubject
    };
    this.socketService.register(newService);
    this.messagesDailyOrder = newService.serviceSubject.pipe(map(data => {
      const messageReturn: MessageDailyOrder[] = [];
      if (data['listBeans'] && Array.isArray(data['listBeans'])) {
        data['listBeans'].forEach(element => {
          if (!element.securityType ||
            (element.securityType && element.securityType.value.toUpperCase() !== 'FUND'
              && element.securityType.value.toUpperCase() !== 'REFI' && element.securityType.value.toUpperCase() !== 'TEDI')) {
            messageReturn.push({
              quote: element.quote ? element.quote.value : null,
              buyOrSell: element.buyOrSell ? element.buyOrSell.value : null,
              account: element.account ? element.account.value : null,
              stateCode: element.state ? element.state.code : null,
              state: element.state ? element.state.value : null,
              quantitySupplied: element.quantitySupplied ? element.quantitySupplied.value : null,
              quantityExecuted: element.quantityExecuted ? element.quantityExecuted.value : null,
              quantityRemaining: element.quantityRemaining ? element.quantityRemaining.value : null,
              price: element.price ? element.price.value : null,
              priceAverage: element.priceAverage ? element.priceAverage.value : null,
              typeCode: element.type ? element.type.code : null,
              type: element.type ? (element.type.value.toLowerCase() === TypeOrderEnum.STOP_LIMIT.toLowerCase() ? TypeOrderEnum.STOP : element.type.value) : null,
              maturity: element.maturity ? element.maturity.value : null,
              mercado: element.mercado ? element.mercado.code : null,
              transactTime: element.transactTime ? element.transactTime.value : null,
              side: element.side ? element.side.value : null,
              currentCumQty: element.currentCumQty ? element.currentCumQty.value : null,
              currentAvgPx: element.currentAvgPx ? element.currentAvgPx.value : null,
              orderID: element.orderID ? element.orderID.value : null,
              orderStrategy: element.orderStrategy ? element.orderStrategy.value : null,
              timeInForceCode: element.timeInForce ? element.timeInForce.code : null,
              timeInForce: element.timeInForce ? this.convertTimeInForce(element.timeInForce.value) : null,
              clOrdID: element.clOrdID ? element.clOrdID.value : null,
              username: element.username ? element.username.value : null,
              text: element.text ? element.text.value : null,
              movingStart: element.movingStart ? element.movingStart.value : null,
              initialChange: element.initialChange ? element.initialChange.value : null,
              priceStopGain: element.priceStopGain ? element.priceStopGain.value : null,
              priceStop: element.priceStop ? element.priceStop.value : null,
              maxFloor: element.maxFloor ? element.maxFloor.value : null,
              minQty: element.minQty ? element.minQty.value : null,
              orderTag: element.orderTag ? element.orderTag.value : null,
              price2: element.price2 ? element.price2.value : null,
              applicationName: element.applicationName ? element.applicationName.value : null,
              workingIndicator: element.workingIndicator ? element.workingIndicator.value : null,
              massStatusReqID: element.massStatusReqID ? element.massStatusReqID.value : ''
            });
          }
        });
      }
      this.updateTempOrder(messageReturn);
      return messageReturn;
    }));
  }

  convertTimeInForce(timeinforce: string): string {
    const  timeInForce = Constants.TIME_IN_FORCES.find(t => t.desc === timeinforce);
    return timeInForce && timeInForce.webfeeder ? timeInForce.webfeeder : timeinforce;
  }

  updateTempOrder(orders) {
    if (this.tempOrders.length === 0) {
      this.tempOrders = orders;
    } else {
      orders.forEach(order => {
        const orderToEdit = this.tempOrders.findIndex(item => item.orderID == order.orderID);
        if (orderToEdit != undefined && orderToEdit != -1) {
          this.tempOrders[orderToEdit] = order;
        } else {
          this.tempOrders.push(order);
        }
      });
    }
  }

  subscribeDailyOrder(account: string, component: string) {
    if (account) {
      component = component ? component.toUpperCase() : component;
      if (this.activeSubscriptions <= 0) {
        this.sendMessageDailyOrder(account, true);
        this.activeSubscriptions = 0;
      }
      const existSubscribe = this.subscribeComponent.find(x => x === component);
      if (!existSubscribe) {
        this.subscribeComponent.push(component);
        this.activeSubscriptions++;
      }
      this.configService.writeLog('SUBSCRIBE DAILYORDER > [' + this.activeSubscriptions + '][BMF/BVSP] Conta -> [' + account + '] > Source -> [' + component + ']  <<<<<');
      return of(this.tempOrders);
    }
    return of(null)
  }

  unsubscribeDailyOrder(account: string, component: string, forceUnsubscribe?: boolean) {
    if (account) {
      component = component ? component.toUpperCase() : component;
      const existSubscribe = this.subscribeComponent.findIndex(x => x === component);
      if (existSubscribe !== -1) {
        this.subscribeComponent.splice(existSubscribe, 1);
        this.activeSubscriptions--;
      }
      if (this.activeSubscriptions <= 0 || forceUnsubscribe) {
        if (forceUnsubscribe) {
          this.activeSubscriptions = 0;
        }
        this.tempOrders = [];
        this.sendMessageDailyOrder(account, false);
      }
      this.configService.writeLog('UNSUBSCRIBE DAILYORDER > [' + this.activeSubscriptions + '][BMF/BVSP] Conta -> [' + account + '] > Source -> [' + component + ']  <<<<<');
    }
  }

  private sendMessageDailyOrder(account: string, dispatch: boolean) {
    const dataMsg: MessageWebFeeder = new MessageWebFeeder();
    dataMsg.token = this.configService.getToken();
    dataMsg.module = 'negotiation';
    dataMsg.service = 'dailyOrder';
    const messageParameter = new MessageParameterNegotiation();
    messageParameter.account = account;
    messageParameter.dispatch = dispatch;
    messageParameter.history = true;
    dataMsg.parameters = messageParameter;
    setTimeout(() => {
      this.socketService.signService(dataMsg);
    }, 1000);
  }

  callAlert(title, message, typeAlert) {
    this.configService.systemNotificationMessage(title, message, typeAlert);
  }

  convertDailyOrderToSendOrder(value) {
    const model: SimpleOrder = new SimpleOrder();
    model.account = value.account;
    model.quote = value.quote;
    model.qtd = Number(value.quantitySupplied);
    model.price = value.price ? value.price.toString().trim() : value.price;
    model.type = value.type ? AppUtils.revertMarketType(value.type.toString()) : value.type;
    model.side = Constants.ORDER_HISTORY_DIRECTIONS.find(x => x.desc === value.side) ?
      Constants.ORDER_HISTORY_DIRECTIONS.find(x => x.desc === value.side).webfeeder : value.side;
    model.orderStrategy = value.orderStrategy;
    model.orderid = value.orderID;
    model.origclordid = value.clOrdID;
    model.maxfloor = value.maxFloor;
    model.minqtd = value.minQty;
    model.orderTag = value.orderTag;
    model.timeInForce = Constants.TIME_IN_FORCES.find(p => p.desc === value.timeInForce || p.webfeeder === value.timeInForce).webfeeder;
    model.quantitySupplied = Number(value.quantitySupplied);
    model.stoptrigger = value.priceStop ? value.priceStop.toString().trim() : value.priceStop;
    model.stoplimit = value.price ? value.price.toString().trim() : value.price;
    model.stopLoss = model.stoptrigger && model.stoplimit ? true : false;
    model.targettrigger = value.priceStopGain ? value.priceStopGain.toString().trim() : value.priceStopGain;
    model.targetlimit = value.price2 ? value.price2.toString().trim() : value.price2;
    model.stopGain = model.targettrigger && model.targetlimit ? true : false;
    model.clordlinkid = value.clOrdID;
    if (value.mercado.toString().toLowerCase() === 'bovespa' || (Number(value.mercado) && value.mercado === MarketEnum.BOVESPA)) {
      model.market = MarketEnum.BOVESPA;
    } else if (value.mercado.toString().toLowerCase() === 'bm&f' || Number(value.mercado) && value.mercado === MarketEnum.BMF) {
      model.market = MarketEnum.BMF;
    } else {
      model.market = value.mercado;
    }
    if (value.maturity) {
      const auxDate = value.maturity ? value.maturity.substring(0, 10).split('/') : null;
      model.validityOrder = auxDate ? new Date(`${auxDate[2]}/${auxDate[1]}/${auxDate[0]}`) : null;
    } else {
      const day = value.transactTime ? value.transactTime.toString().substring(0, 2) : null;
      const month = value.transactTime ? value.transactTime.toString().substring(3, 5) : null;
      const year = value.transactTime ? value.transactTime.toString().substring(6, 10) : null;
      model.validityOrder = day && month && year ? new Date(year, month - 1, day) : null;
    }
    return model;
  }

  transformCancelOrder(data: any): any {
    try {
      const messageReturn: CancelOrder = new CancelOrder;
      messageReturn.username = data.account;
      messageReturn.orderid = data.orderID;
      messageReturn.origclordid = data.origclordid || data.clOrdID;
      messageReturn.clOrdID = data.clOrdID;
      messageReturn.market = Constants.ORDER_HISTORY_MARKETS.find(x => x.desc === data.mercado || x.webfeeder === data.mercado).cod.toString();
      messageReturn.quote = data.quote;
      messageReturn.qtd = data.quantitySupplied;
      messageReturn.side = data.side;
      messageReturn.side = data.side.toString().toLowerCase() === 'compra' ? SideEnum.BUY : data.side.toString().toLowerCase() === 'venda' ? SideEnum.SELL : data.side;
      messageReturn.username = data.username;
      messageReturn.enteringtrader = data.enteringtrader || data.account;
      return messageReturn;
    } catch (error) {
      this.callAlert('', Constants.ERROR_ERROR_TITLE, Constants.ALERT_TYPE.error);
      this._cancelOrderConfirmation.next(false);
    }
  }

  removeSuffixPriceNumber(value, market) {
    if (value) {
      switch (market) {
        case MarketTypeEnum.BOVESPA:
        case MarketEnum.BOVESPA:
          value = value.toString().indexOf(',') === -1 ? value.toString().trim().replace('R$ ', '').replace(',', '.')
            : value.toString().trim().replace('R$ ', '').replace('.', '').replace(',', '.');
          return Number(value.toString().trim());
        case MarketTypeEnum.BMF:
        case MarketEnum.BMF:
          value = value.toString().indexOf(',') !== -1 ? value.toString().trim().replace('Pts. ', '').replace('.', '').replace(',', '.')
            : value.toString().trim().replace('Pts. ', '');
          return Number(value.toString().trim());
        default:
          return value;
      }
    }
  }

  verifyEletronicSignature(typeRequest: TypeOrderRequestEnum, params: any, // Default
    isCancelAllOrder?: boolean, priceCancel?, sideEditCancel?: SideEnum, // cancelar ordem
    priceEditOld?, priceEditNew?, tickSize?: number // Editar Ordem
  ) {
    if (typeRequest === TypeOrderRequestEnum.CANCEL_ALL_ORDER && (!params)) {
      this.callAlert('', Constants.BILLET_ORDER_MSG001, Constants.ALERT_TYPE.warn);
      return false;
    } else if (typeRequest === TypeOrderRequestEnum.EDIT_ALL_ORDER && (!params || !priceEditOld || !priceEditNew)) {
      this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.warn);
      return false;
    } else if (typeRequest === TypeOrderRequestEnum.EDIT_ORDER && (params && (params.qtd == null || params.qtd <= 0))) {
      this.callAlert('', Constants.BILLET_ORDER_MSG002, Constants.ALERT_TYPE.warn);
      return false;
    } else if (typeRequest === TypeOrderRequestEnum.SEND_ORDER) {
      if (params && !params.account) {
        this.callAlert('', Constants.WORKSPACE_MSG021, Constants.ALERT_TYPE.error);
        return false;
      } else if (params && (params.qtd == null || params.qtd <= 0)) {
        this.callAlert('', Constants.BILLET_ORDER_MSG002, Constants.ALERT_TYPE.warn);
        return false;
      } else if (params && ((params.price == null || params.price) && Number(params.price) <= 0)) {
        this.callAlert('', Constants.BILLET_ORDER_MSG006, Constants.ALERT_TYPE.warn);
        return false;
      } else if (params && (!params.quote || params.quote === '')) {
        this.callAlert('', Constants.BILLET_ORDER_MSG001, Constants.ALERT_TYPE.warn);
        return false;
      }
    }
    if (typeRequest === TypeOrderRequestEnum.EDIT_ALL_ORDER) {
      this.sendEditAllOrder(params, sideEditCancel, priceEditOld, priceEditNew, tickSize);
    } else {
      const isAssessor = this.configService.isUserAssessorLogged();
      const eletronicSignature = this.configService.getEletronicSignatureType();
      const validSignature = eletronicSignature && !eletronicSignature.isActive ? true : false;
      if (typeRequest === TypeOrderRequestEnum.SEND_ORDER) {
        params.type = AppUtils.revertMarketType(params.type.toString());
        params.qtd = Number(params.qtd);
      }
      this.validEletronicSignature(typeRequest, params, eletronicSignature, validSignature, isAssessor, // Default
        isCancelAllOrder, priceCancel, sideEditCancel // cancelar ordem
      );
    }
    return false;
  }

  validEletronicSignature(typeRequest: TypeOrderRequestEnum, value: any, eletronicSignature, validSignature, isAssessor: boolean, // Default
    isCancelAllOrder?: boolean, priceCancel?, side?: SideEnum, // cancelar ordem
  ) {
    const loginTypeEnable = this.configService.getLoginTypeEnabled();
    if (eletronicSignature && eletronicSignature.isActive && !this.configService.isUserAssessorLogged()) {
      if (this.configService.getHbSignature()) {
        value.signature = this.configService.getHbSignature();
      }
      if (!value.signature && (loginTypeEnable === Constants.LOGIN_TYPE.LoginW || loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
        const dialogConfig = this.dialog.open(EletronicSignatureModalComponent, {
          panelClass: Constants.ELETRONIC_SIGNATURE_MODAL, width: '350px', disableClose: true
        });
        dialogConfig.componentInstance.title = 'Confirme sua operação';
        dialogConfig.componentInstance.confirmText = 'Confirmar';
        dialogConfig.afterClosed().subscribe(result => {
          validSignature = result.validSignature;
          if (validSignature) {
            switch (typeRequest) {
              case TypeOrderRequestEnum.CANCEL_ORDER:
                this.cancelOrder(value, result.signature, isCancelAllOrder);
                break;
              case TypeOrderRequestEnum.CANCEL_ALL_ORDER:
                this.cancelAllOrders(value, result.signature, priceCancel, side);
                break;
              case TypeOrderRequestEnum.SEND_ORDER:
              case TypeOrderRequestEnum.EDIT_ORDER:
                this.validSuitability(value, validSignature, isAssessor, eletronicSignature, result.signature);
                break;
            }
          } else {
            this.callAlert('', Constants.BILLET_ORDER_SEND_06, Constants.ALERT_TYPE.warn);
            return false;
          }
          return false;
        });
      } else {
        let params;
        if (eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.string) {
          const clientId = Number(this.configService.getHbAccountId());
          params = { user_client_id: clientId, signature: value.signature };
        } else {
          params = value.signature;
        }
        this.authServer.iEletronicSignature.validateSignature(params)
          .subscribe(res => {
            if ((eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.string && res && res._isScalar !== false && res.is_valid) ||
              (eletronicSignature.type === Constants.ELETRONIC_SIGNATURE_TYPES.virtual_keyboard &&
                res && res.IsResponseOk && res.SerializedObject && JSON.parse(res.SerializedObject).Autenticado)) {
              validSignature = true;
              switch (typeRequest) {
                case TypeOrderRequestEnum.CANCEL_ORDER:
                  this.cancelOrder(value, res.signature, isCancelAllOrder);
                  break;
                case TypeOrderRequestEnum.CANCEL_ALL_ORDER:
                  this.cancelAllOrders(value, res.signature, priceCancel, side);
                  break;
                case TypeOrderRequestEnum.SEND_ORDER:
                case TypeOrderRequestEnum.EDIT_ORDER:
                  this.validSuitability(value, validSignature, isAssessor, eletronicSignature, res.signature);
                  break;
              }
            } else {
              this.callAlert('', Constants.BILLET_ORDER_SEND_07, Constants.ALERT_TYPE.error);
              this.configService.deleteHbSignature();
              value.signature = null;
              this.validEletronicSignature(typeRequest, value, eletronicSignature, validSignature, isAssessor);
            }
          });
      }
    } else {
      switch (typeRequest) {
        case TypeOrderRequestEnum.CANCEL_ORDER:
          this.cancelOrder(value, validSignature, isCancelAllOrder);
          break;
        case TypeOrderRequestEnum.CANCEL_ALL_ORDER:
          this.cancelAllOrders(value, validSignature, priceCancel, side);
          break;
        case TypeOrderRequestEnum.SEND_ORDER:
        case TypeOrderRequestEnum.EDIT_ORDER:
          this.validSuitability(value, validSignature, eletronicSignature, isAssessor);
          break;
      }
    }
  }

  validSuitability(model: SimpleOrder, validSignature: boolean, isAssessor: boolean, eletronicSignature, signature?) {


    let accountSelectBrokerTemp: any = [];
    let termOperator = false;
    model.account = (model && model.account) ? model.account : model.enteringtrader;
    const loginTypeEnable = this.configService.getLoginTypeEnabled();
    const isLoginW = this.configService.isLoginTypeWSO2();
    const accountBrokerList = !isAssessor ? this.configService.getBrokerAccountList() : this.configService.getAssessorClientSelected();

    if (!isLoginW) {
      let bovespaList = [Constants.MARKET_BOVESPA, Constants.MARKET_BOVESPA2, MarketEnum.BOVESPA, String(MarketEnum.BOVESPA)]
      let bmfList = [Constants.MARKET_BMF, Constants.MARKET_BMF2, MarketEnum.BMF, String(MarketEnum.BMF)]

      if (accountBrokerList && accountBrokerList.length >= 1) {
        accountBrokerList.forEach(element => {

          if (model && element.account === model.account && (bovespaList.includes(element.market) && bovespaList.includes(model.market))) {
            accountSelectBrokerTemp = element;
            return;
          } else if (model && element.account === model.account && (bmfList.includes(element.market) && bmfList.includes(model.market))) {
            accountSelectBrokerTemp = element;
            return;
          }
        });
      } else if (accountBrokerList && (bovespaList.includes(accountBrokerList.market) && bovespaList.includes(model.market))) {
        accountSelectBrokerTemp = accountBrokerList;
      } else if (accountBrokerList && (bmfList.includes(accountBrokerList.market) && bmfList.includes(model.market))) {
        accountSelectBrokerTemp = accountBrokerList;
      }
    } else if (isLoginW) {

      if (isAssessor) {
        accountSelectBrokerTemp = accountBrokerList.markets.find(x =>
          ((x === Constants.MARKET_BOVESPA || x === Constants.MARKET_BOVESPA2) && model && model.market === MarketEnum.BOVESPA) ||
          ((x === Constants.MARKET_BMF || x === Constants.MARKET_BMF2) && model.market === MarketEnum.BMF)
        );
        if (accountSelectBrokerTemp) {
          accountSelectBrokerTemp = accountBrokerList;
        }
      } else {
        if (accountBrokerList && accountBrokerList.length > 0) {
          accountBrokerList.forEach(element => {
            if ((element.market === Constants.MARKET_BOVESPA || element.market === Constants.MARKET_BOVESPA2) && model && model.market === MarketEnum.BOVESPA) {
              accountSelectBrokerTemp = element;
              return;
            } else if ((element.market === Constants.MARKET_BMF || element.market === Constants.MARKET_BMF2) && model.market === MarketEnum.BMF) {
              accountSelectBrokerTemp = element;
              return;
            }
          });
        } else {
          if (((accountBrokerList.market === Constants.MARKET_BOVESPA || accountBrokerList.market === Constants.MARKET_BOVESPA2)
            && (model && model.market === MarketEnum.BOVESPA)) ||
            ((accountBrokerList.market === Constants.MARKET_BMF || accountBrokerList.market === Constants.MARKET_BMF2) && model.market === MarketEnum.BMF)) {
            accountSelectBrokerTemp = accountBrokerList;
          }
        }
      }
    }

    if (!accountSelectBrokerTemp || (accountSelectBrokerTemp && accountSelectBrokerTemp.length <= 0)) {
      const market = model.market === MarketEnum.BOVESPA ? 'Bovespa' : model.market === MarketEnum.BMF ? 'BMF' : ' do ativo selecionado.';
      this.callAlert('', 'Conta ' + model.account + ' não encontrada no mercado ' + market, Constants.ALERT_TYPE.info);
      termOperator = false;
      return false;
    }
    if (accountSelectBrokerTemp && accountSelectBrokerTemp.validateSuitability) {
      let profileName = '';
      let client_id = 0;
      let suitabilityID;
      if (this.configService.isLoginTypeWSO2() && this.configService.isUserAssessorLogged()) {
        profileName = accountSelectBrokerTemp && accountSelectBrokerTemp.profile_name ? accountSelectBrokerTemp.profile_name : null;
        client_id = accountSelectBrokerTemp && accountSelectBrokerTemp.client_id ? accountSelectBrokerTemp.client_id : null;
        suitabilityID = accountSelectBrokerTemp && accountSelectBrokerTemp.suitabilityID ? accountSelectBrokerTemp.suitabilityID : null;
      } else {
        client_id = this.configService.getHbAccountId() ? Number(this.configService.getHbAccountId()) : null;
        profileName = accountSelectBrokerTemp && accountSelectBrokerTemp.profileName ? accountSelectBrokerTemp.profileName : null;
        suitabilityID = accountSelectBrokerTemp && accountSelectBrokerTemp.suitabilityID ? accountSelectBrokerTemp.suitabilityID : null;
      }
      if (!suitabilityID) {
        this.callAlert('', Constants.BILLET_ORDER_SEND_04, Constants.ALERT_TYPE.warn);
        return false;
      }
      this.authServer.iSuitabilityService.suitabilityCheckMatrix(model.account, model.market, null, 0, model.quote, suitabilityID, profileName, client_id)
        .subscribe(res => {
          if (res && (res._isScalar === false || res.error === true || res.error === 'true')) {
            termOperator = false;
            this.callAlert('', res.error_message ? res.error_message : Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
            return false;
          } else if (res && this.configService.isLoginTypeWSO2() && res.is_out_of_bounds === false && res._isScalar !== false) {

            if (model.side === SideEnum.BUY && environment.SIGN_TERM_SUITABILITY_IN_BUY && (environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_BUY && (res.assign_bounds_id > 0))) {
              this.handleTerm({model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature, res});
              return
            }
            if (model.side === SideEnum.SELL && environment.SIGN_TERM_SUITABILITY_IN_SELL && (environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_SELL && (res.assign_bounds_id > 0))) {
              this.handleTerm({model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature, res});
              return
            }

            model.bypasssuitability = accountSelectBrokerTemp.validateSuitability ? true : null;
            this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
          } else if (res.code && res.code.toString() === '200' && (res.message === 'true' || res.message === true)) {
            model.bypasssuitability = accountSelectBrokerTemp.validateSuitability ? true : null;
            this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
          } else if (res && res.error == false && res.profile_framed) {
            model.bypasssuitability = accountSelectBrokerTemp.validateSuitability ? true : null;
            this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
          } else if (res && res.error == false && ((res.view_term) || (res.profile_framed == false && res.is_signed == false))) {

            if (model.side === SideEnum.BUY && environment.SIGN_TERM_SUITABILITY_IN_BUY && (environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_BUY  || (!environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_BUY && (res.assign_bounds_id > 0)))) {
              this.handleTerm({model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature, res});
              return
            }
            if (model.side === SideEnum.SELL && environment.SIGN_TERM_SUITABILITY_IN_SELL && (environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_SELL  || (!environment.ALWAYS_RE_SIGN_TERM_SUITABILITY_IN_SELL && (res.assign_bounds_id > 0)))) {
              this.handleTerm({model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature, res});
              return
            }
            model.bypasssuitability = accountSelectBrokerTemp.validateSuitability ? true : null;
            this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
          } else if (res && !res.error && !res.view_term) {
            model.bypasssuitability = res.is_signed;
            termOperator = false;
            this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
          } else if (res && ((res.is_out_of_bounds && res._isScalar !== false))
            || (res && res.code.toString() === '200' && (res.message === 'false' || res.message === false))) {

              if (model.side === SideEnum.BUY && environment.SIGN_TERM_SUITABILITY_IN_BUY) {
                this.handleTerm({model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature, res});
                return
              }
              if (model.side === SideEnum.SELL && environment.SIGN_TERM_SUITABILITY_IN_SELL) {
                this.handleTerm({model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature, res});
                return
              }
              model.bypasssuitability = accountSelectBrokerTemp.validateSuitability ? true : null;
              this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
            // const term = {
            //   type_term: loginTypeEnable === Constants.LOGIN_TYPE.LoginA ? res.type_term : Constants.TERM_OPERATOR_TYPES.TEXT,
            //   security_type: res.security_type || null, pdf: res.term || null
            // };
            // termOperator = true;
            // this.openTermOperatorModal(model, accountBrokerList, term, termOperator, eletronicSignature, validSignature, isAssessor, signature);
          } else {
            termOperator = false;
            this.callAlert('', Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
            return false;
          }
          return false;
        }, () => {
          termOperator = false;
          this.callAlert('', Constants.BILLET_ORDER_SEND_05, Constants.ALERT_TYPE.error);
          return false;
        });
    } else {
      this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
    }
    return false;
  }

  handleTerm(data) {
    let  {model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature, loginTypeEnable, res} = data;
    const term = {
      type_term: loginTypeEnable === Constants.LOGIN_TYPE.LoginA ? res.type_term : Constants.TERM_OPERATOR_TYPES.TEXT,
      security_type: res.security_type || null, pdf: res.term || null
    };
    termOperator = true;
    this.openTermOperatorModal(model, accountBrokerList, term, termOperator, eletronicSignature, validSignature, isAssessor, signature);
  }


  openTermOperatorModal(model: SimpleOrder, accountBrokerList, term, termOperator, eletronicSignature, validSignature, isAssessor, signature) {
    const organization = this.configService.getConfigWhitelabel();
    if (isAssessor && (!organization.billet.advisorCanAcceptTerm || (organization.billet.advisorCanAcceptTerm && !this.configService.getAdisorGestorCanAcceptTerm()))) {
      this.callAlert('', Constants.BILLET_ORDER_SEND_08, Constants.ALERT_TYPE.warn);
      termOperator = false;
      return false;
    }
    termOperator = true;
    model.security_type = term.security_type;
    const messages = { title: Constants.WORKSPACE_MSG036, subTitle: Constants.WORKSPACE_MSG037, messageCheck: Constants.WORKSPACE_MSG035 };
    const dialogConfig = this.dialog.open(TermOperatorModalComponent, {
      panelClass: Constants.TERM_OPERATOR_MODAL, disableClose: true,
      width: '500px', data: { messages: messages, term: term }
    });
    dialogConfig.afterClosed().subscribe(res => {
      model.bypasssuitability = res;
      this.emitOrder(model, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature);
    });
    return false;
  }

  cancelAllOrders(quote: string, signature, price?, side?: SideEnum) {
    if (this.tempOrders && this.tempOrders.length > 0) {
      const openStatus = ['0', '1', '5', 'A', 'E', 'R'];
      let noOrdersCancel = true;
      let showSendCancelNotification = true;
      this.tempOrders.forEach(element => {
        if (openStatus.includes(element.stateCode) && element.quote.toUpperCase() === quote.toUpperCase()) {
          const sideTemp = element.side.toUpperCase() === 'COMPRA' ? SideEnum.BUY : SideEnum.SELL;
          if (side && sideTemp !== side) {
            return;
          }
          noOrdersCancel = false;
          const elementPricetemp = this.removeSuffixPriceNumber(element.type === TypeOrderEnum.STOP ? element.priceStop : element.price, element.mercado);
          const priceTemp = this.removeSuffixPriceNumber(price, element.mercado);
          if (!price || (priceTemp && elementPricetemp && elementPricetemp === priceTemp)) {
            const cancelOrder: CancelOrder = this.transformCancelOrder(element);
            setTimeout(() => {
              if (showSendCancelNotification) {
                this.callAlert('', Constants.BILLET_ORDER_SEND_10, Constants.ALERT_TYPE.info);
                showSendCancelNotification = false;
              }
              this.cancelOrder(cancelOrder, signature, true);
            }, 1000);
          }
        }
      });
      if (noOrdersCancel) {
        this.callAlert('', Constants.ORDER_HISTORY_MSG009.replace('[QUOTE]', quote.toUpperCase()), Constants.ALERT_TYPE.error);
      }
    }
  }

  cancelOrder(cancelOrder: CancelOrder, signature?, isCancelAllOrder?: boolean) {
    const account = this.configService.getBrokerAccountSelected();
    if (
      this.configService.isLoginTypeWSO2() ||
      this.configService.isLoginTypeIAM() ||
      this.configService.getLoginTypeEnabled() === Constants.LOGIN_TYPE.LoginA
    ) { // WSO2
      this.authServer.iNegotiation.cancelOrderWso2(account, cancelOrder.username, cancelOrder.orderid,
        cancelOrder.clOrdID, cancelOrder.market, cancelOrder.quote, cancelOrder.qtd, cancelOrder.side, account, signature)
        .subscribe(res => {
          if (res.code === 1 && !isCancelAllOrder) {
            this.callAlert('', Constants.BILLET_ORDER_SEND_10, Constants.ALERT_TYPE.info);
            this._cancelOrderConfirmation.next(true);
          } else if (res.code !== 1) {
            this.callAlert('', Constants.BILLET_ORDER_SEND_09, Constants.ALERT_TYPE.error);
            this._cancelOrderConfirmation.next(false);
          }
        }, () => {
          this.callAlert('', Constants.BILLET_ORDER_SEND_09, Constants.ALERT_TYPE.error);
          this._cancelOrderConfirmation.next(false);
        });
    } else {
      this.authServer.iNegotiation.cancelOrderApi(account, cancelOrder.username, cancelOrder.orderid,
        cancelOrder.clOrdID, cancelOrder.market, cancelOrder.quote, cancelOrder.qtd, cancelOrder.side, account)
        .subscribe(res => {
          if (res.code === 1 && !isCancelAllOrder) {
            this.callAlert('', Constants.BILLET_ORDER_SEND_10, Constants.ALERT_TYPE.error);
            this._cancelOrderConfirmation.next(true);
          } else if (res.code !== 1) {
            this.callAlert('', Constants.BILLET_ORDER_SEND_09, Constants.ALERT_TYPE.error);
            this._cancelOrderConfirmation.next(false);
          }
        }, () => {
          this.callAlert('', Constants.BILLET_ORDER_SEND_09, Constants.ALERT_TYPE.error);
          this._cancelOrderConfirmation.next(false);
        });
    }
  }

  emitOrder(model: SimpleOrder, accountBrokerList, termOperator, eletronicSignature, validSignature, isAssessor, signature?) {
    const isOrderStopSimultaneous = this.configService.isTypeBilletStopSimultaneousOrOco();
    const organization = this.configService.getConfigWhitelabel();
    if (termOperator && !model.bypasssuitability) {
      this.callAlert('', Constants.WORKSPACE_MSG023, Constants.ALERT_TYPE.warn);
      return false;
    }
    if (eletronicSignature && eletronicSignature.isActive && !validSignature && !isAssessor) {
      this.callAlert('', Constants.BILLET_ORDER_VALID_SIGNATURE, Constants.ALERT_TYPE.error);
      return false;
    }
    let client_id = 0;
    let user_id = 0;
    if (this.configService.isLoginTypeWSO2() && this.configService.isUserAssessorLogged()) {
      client_id = accountBrokerList.client_id;
      user_id = Number(this.configService.getAssessorId());
    } else if (this.configService.isLoginTypeWSO2()) {
      client_id = Number(this.configService.getHbAccountId());
      user_id = Number(this.configService.getHbUserId());
    }
    if (model.type !== TypeOrderEnum.STOP) {
      this.sendOrderSingle(model, isOrderStopSimultaneous, client_id, user_id, model.price, model.type, signature, termOperator);
    } else {
      let priceTemp: any;
      let GainTrigger: string;
      let GainExecution: string;
      let LossTrigger: string;
      let LossExecution: string;
      if (isOrderStopSimultaneous && isOrderStopSimultaneous && model.stopLoss && model.stopGain) {
        if (model.side === SideEnum.BUY) {
          LossTrigger = this.removeSuffixPriceNumber(model.stoptrigger, model.market);
          LossExecution = this.removeSuffixPriceNumber(model.stoplimit, model.market);
          GainTrigger = this.removeSuffixPriceNumber(model.targettrigger, model.market);
          GainExecution = this.removeSuffixPriceNumber(model.targetlimit, model.market);
        } else if (model.side === SideEnum.SELL) {
          GainTrigger = this.removeSuffixPriceNumber(model.targettrigger, model.market);
          GainExecution = this.removeSuffixPriceNumber(model.targetlimit, model.market);
          LossTrigger = this.removeSuffixPriceNumber(model.stoptrigger, model.market);
          LossExecution = this.removeSuffixPriceNumber(model.stoplimit, model.market);
        }
      } else if (isOrderStopSimultaneous && isOrderStopSimultaneous && model.stopGain) {
        // Only for up
        if (model.side === SideEnum.BUY) {
          LossTrigger = null;
          LossExecution = null;
          GainTrigger = this.removeSuffixPriceNumber(model.targettrigger, model.market);
          GainExecution = this.removeSuffixPriceNumber(model.targetlimit, model.market);
        } else if (model.side === SideEnum.SELL) {
          GainTrigger = this.removeSuffixPriceNumber(model.targettrigger, model.market);
          GainExecution = this.removeSuffixPriceNumber(model.targetlimit, model.market);
          LossTrigger = '0';
          LossExecution = '0';
        }
      } else {
        // Only for down
        if (!isOrderStopSimultaneous) {
          priceTemp = model.targetlimit;
        }
        if (model.side === SideEnum.BUY) {
          LossTrigger = this.removeSuffixPriceNumber(model.stoptrigger, model.market);
          LossExecution = this.removeSuffixPriceNumber(model.stoplimit, model.market);
          GainTrigger = '0';
          GainExecution = '0';
        } else if (model.side === SideEnum.SELL) {
          GainTrigger = null;
          GainExecution = null;
          LossTrigger = this.removeSuffixPriceNumber(model.stoptrigger, model.market);
          LossExecution = this.removeSuffixPriceNumber(model.stoplimit, model.market);
        }
      }
      model.clordlinkid = organization.billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.OCO ?
        (this.configService.getBrokerAccount() + this._datePipe.transform(new Date(), 'yyyyMMddHHmmss')).toUpperCase() : null;
      this.sendOrderStop(model, isOrderStopSimultaneous, client_id, user_id, priceTemp, GainTrigger, GainExecution, LossTrigger,
        LossExecution, signature, termOperator);
    }
    return false;
  }

  sendOrderSingle(model: SimpleOrder, isOrderStopSimultaneous, client_id, user_id, price, typeOrder?, signature?, sendTermSuitability?: boolean) {
    const loginTypeEnable = this.configService.getLoginTypeEnabled();
    if (loginTypeEnable !== Constants.LOGIN_TYPE.LoginIAM && loginTypeEnable !== Constants.LOGIN_TYPE.LoginW && loginTypeEnable !== Constants.LOGIN_TYPE.LoginA) { // FACADE
      this.authServer.iNegotiation.sendOrderApi(model.account, model.quote, model.qtd, price.toString(), model.market,
        isOrderStopSimultaneous ? model.type : typeOrder, model.side, model.validityOrder, model.orderStrategy,
        model.timeInForce, model.orderid, model.origclordid, model.loteDefault,
        model.maxfloor > 0 ? `${model.maxfloor}` : null, model.minqtd > 0 ? `${model.minqtd}` : null,
        model.orderTag, model.bypasssuitability, model.clordlinkid)
        .subscribe(res => {
          if (res.code === 1) {
            if (res.message && res.message.split(';').length > 1) {
              const msg01 = JSON.parse(res.message.split(';')[0]);
              const msg02 = JSON.parse(res.message.split(';')[1]);
              if (msg01 && msg01.code === 1 && msg02 && msg02.code === 1) {
                this.callAlert('', 'Enviando orden(s) dos ativos ' + model.quote.toUpperCase() +
                  ' e ' + model.quote.toUpperCase() + 'F...', Constants.ALERT_TYPE.warn);
              }
            } else {
              this.callAlert('', Constants.BILLET_ORDER_SEND_01, Constants.ALERT_TYPE.warn);
            }
            this._orderSentSuccess.next(true);
            this._showHiddenPadOrderConfirmation.next(true);
          } else if (res.code === 2) {
            if (res.message && res.message.split(';').length > 0) {
              const msg01 = JSON.parse(res.message.split(';')[0]);
              const msg02 = JSON.parse(res.message.split(';')[1]);
              if (msg01 && msg01.code === 1) {
                this.callAlert('', msg01.message, Constants.ALERT_TYPE.warn);
              } else {
                this.callAlert('', msg01.message, Constants.ALERT_TYPE.error);
              }
              if (msg02 && msg02.code === 1) {
                this.callAlert('', msg02.message, Constants.ALERT_TYPE.warn);
              } else {
                this.callAlert('', msg02.message, Constants.ALERT_TYPE.error);
              }
            }
            this._showHiddenPadOrderConfirmation.next(true);
          } else {
            this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
            this._showHiddenPadOrderConfirmation.next(false);
          }
        }, () => {
          this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
        });
    } else { // WSO2
      const validSuitabilityOms = environment.SUITABILITY_OMS;
      const sendSecondOrder = !model.loteDefault || model.qtd % Number(model.loteDefault) === 0 ? false : true;
      const fractionaryQtd = sendSecondOrder ? (model.qtd - (model.qtd - (model.qtd % Number(model.loteDefault)))) : 0;
      const nonFractionaryQtd = sendSecondOrder ? model.qtd - fractionaryQtd : model.qtd;
      if (model.qtd < Number(model.loteDefault) || model.quote.toLowerCase().endsWith('f')) {
        this.sendOrderFractional(
          model,
          isOrderStopSimultaneous,
          client_id,
          user_id,
          price,
          true,
          model.qtd,
          validSuitabilityOms,
          loginTypeEnable,
          typeOrder,
          signature,
          sendTermSuitability
        );
        return;
      }
      this.authServer.iNegotiation.sendOrderWso2(model.account, model.quote, fractionaryQtd, nonFractionaryQtd,
        price.toString(), model.market, isOrderStopSimultaneous ? model.type : typeOrder, model.side,
        model.validityOrder, model.orderStrategy, model.timeInForce, model.orderid, model.origclordid,
        model.loteDefault, model.maxfloor > 0 ? `${model.maxfloor}` : null, model.minqtd > 0 ? `${model.minqtd}` : null,
        model.orderTag, null, null, null, null, false, model.bypasssuitability, model.clordlinkid, signature)
        .subscribe(res => {
          if (res.code === 1) {
              this.sendOrderFractional(
                model,
                isOrderStopSimultaneous,
                client_id,
                user_id,
                price,
                sendSecondOrder,
                fractionaryQtd,
                validSuitabilityOms,
                loginTypeEnable,
                typeOrder,
                signature,
                sendTermSuitability
              );
            this._orderSentSuccess.next(true);
            this._showHiddenPadOrderConfirmation.next(true);
          } else {
            this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
            this._showHiddenPadOrderConfirmation.next(true);
          }
        }, () => {
          this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
          this._showHiddenPadOrderConfirmation.next(true);
        });
    }
  }

  sendOrderFractional(
    model: SimpleOrder,
    isOrderStopSimultaneous,
    client_id,
    user_id,
    price,
    sendSecondOrder: boolean,
    fractionaryQtd: number,
    validSuitabilityOms: boolean,
    loginTypeEnable,
    typeOrder?,
    signature?,
    sendTermSuitability?: boolean,
  ) {
    if (sendSecondOrder && fractionaryQtd > 0) {
      const organization = this.configService.getConfigWhitelabel();
      model.clordlinkid = organization.billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.OCO ? model.clordlinkid + 'F' : null;
      this.authServer.iNegotiation.sendOrderWso2(model.account, (model.quote.toLowerCase().endsWith('f') ? model.quote : model.quote + 'F'), fractionaryQtd, 0,
        model.price.toString(), model.market, isOrderStopSimultaneous ? model.type : typeOrder, model.side,
        model.validityOrder, model.orderStrategy, model.timeInForce, model.orderid, model.origclordid,
        model.loteDefault, null, null, null, null, null, null, null, false, model.bypasssuitability, model.clordlinkid, signature)
        .subscribe(res2 => {
          if (res2.code === 1) {
            this._orderSentSuccess.next(true);
            this.callAlert('', Constants.BILLET_ORDER_SEND_01, Constants.ALERT_TYPE.warn);
          } 
          if (sendTermSuitability && model.bypasssuitability &&
            ((this.configService.isLoginTypeWSO2() && !validSuitabilityOms) || loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
            this.authServer.iSuitabilityService.postAssignBounds(model.account, model.quote, client_id, user_id, model.market, model.security_type)
              .subscribe(res3 => {
                if (res3) {
                  this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
                  model.bypasssuitability = false;
                }
              }, () => {
                this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
              });
          }
        }, () => {
          this._showHiddenPadOrderConfirmation.next(true);
          this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
        });
    } else {
      this.callAlert('', Constants.BILLET_ORDER_SEND_01, Constants.ALERT_TYPE.warn);
      if (sendTermSuitability && model.bypasssuitability &&
        ((this.configService.isLoginTypeWSO2() && !validSuitabilityOms) || loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
        this.authServer.iSuitabilityService.postAssignBounds(model.account, model.quote, client_id, user_id, model.market, model.security_type)
          .subscribe(res3 => {
            if (res3) {
              this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
            }
          }, () => {
            this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
          });
      }
    }
  }

  sendOrderStop(model: SimpleOrder, isOrderStopSimultaneous, client_id, user_id, priceTemp, GainTrigger, GainExecution, LossTrigger, LossExecution, signature,
    sendTermSuitability?: boolean) {
    const loginTypeEnable = this.configService.getLoginTypeEnabled();
    if (
      loginTypeEnable !== Constants.LOGIN_TYPE.LoginW &&
      loginTypeEnable !== Constants.LOGIN_TYPE.LoginIAM &&
      loginTypeEnable !== Constants.LOGIN_TYPE.LoginA
    ) { // FACADE
      this.authServer.iNegotiation.sendOrderStopApi(model.account, model.validityOrder, model.orderStrategy,
        model.quote, model.qtd, GainTrigger, GainExecution, LossTrigger, LossExecution, model.market,
        model.side, model.timeInForce, model.orderid, model.origclordid, model.loteDefault, null,
        model.maxfloor > 0 ? `${model.maxfloor}` : null, model.minqtd > 0 ? `${model.minqtd}` : null,
        model.orderTag, model.bypasssuitability, model.clordlinkid)
        .subscribe(res => {
          if (res.code === 1) {
            if (res.message && res.message.split(';').length > 1) {
              const msg01 = JSON.parse(res.message.split(';')[0]);
              const msg02 = JSON.parse(res.message.split(';')[1]);
              if (msg01 && msg01.code === 1 && msg02 && msg02.code === 1) {
                this.callAlert('', 'Enviando orden(s) dos ativos ' + model.quote.toUpperCase() +
                  ' e ' + model.quote.toUpperCase() + 'F...', Constants.ALERT_TYPE.warn);
              }
            } else {
              this.callAlert('', Constants.BILLET_ORDER_SEND_01, Constants.ALERT_TYPE.warn);
            }
            this._orderSentSuccess.next(true);
            this._showHiddenPadOrderConfirmation.next(true);
          } else if (res.code === 2) {
            if (res.message && res.message.split(';').length > 0) {
              const msg01 = JSON.parse(res.message.split(';')[0]);
              const msg02 = JSON.parse(res.message.split(';')[1]);
              if (msg01 && msg01.code === 1) {
                this.callAlert('', msg01.message, Constants.ALERT_TYPE.warn);
              } else {
                this.callAlert('', msg01.message, Constants.ALERT_TYPE.error);
              }
              if (msg02 && msg02.code === 1) {
                this.callAlert('', msg02.message, Constants.ALERT_TYPE.warn);
              } else {
                this.callAlert('', msg02.message, Constants.ALERT_TYPE.error);
              }
            }
            this._showHiddenPadOrderConfirmation.next(true);
          } else {
            this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
          }
          if (!isOrderStopSimultaneous) {
            this.sendOrderSingle(model, isOrderStopSimultaneous, client_id, user_id, priceTemp, TypeOrderEnum.LIMITED, signature);
          } else {
            this._showHiddenPadOrderConfirmation.next(true);
          }
        }, () => {
          this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
          this._showHiddenPadOrderConfirmation.next(true);
        });
    } else {
      const validSuitabilityOms = environment.SUITABILITY_OMS;
      const sendSecondOrder = !model.loteDefault || model.qtd % Number(model.loteDefault) === 0 ? false : true;
      const fractionaryQtd = sendSecondOrder ? (model.qtd - (model.qtd - (model.qtd % Number(model.loteDefault)))) : 0;
      const nonFractionaryQtd = sendSecondOrder ? model.qtd - fractionaryQtd : model.qtd;
      this.authServer.iNegotiation.sendOrderWso2(model.account, model.quote, fractionaryQtd, nonFractionaryQtd,
        null, model.market, model.type, model.side, model.validityOrder, model.orderStrategy,
        model.timeInForce, model.orderid, model.origclordid, model.loteDefault,
        model.maxfloor > 0 ? `${model.maxfloor}` : null, model.minqtd > 0 ? `${model.minqtd}` : null,
        model.orderTag, GainTrigger, GainExecution, LossTrigger, LossExecution, true, model.bypasssuitability, model.clordlinkid, signature)
        .subscribe(res => {
          if (res.code === 1) {
            this._orderSentSuccess.next(true);
            if (sendSecondOrder && fractionaryQtd > 0) {
              const organization = this.configService.getConfigWhitelabel();
              model.clordlinkid = organization.billet.isTypeBilletStopSimultaneousOrOco === BilletOrderTypeEnum.OCO ? model.clordlinkid + 'F' : null;
              this.authServer.iNegotiation.sendOrderWso2(model.account, model.quote + 'F', fractionaryQtd, 0, null,
                model.market, model.type, model.side, model.validityOrder, model.orderStrategy,
                model.timeInForce, model.orderid, model.origclordid, model.loteDefault, null, null, null,
                GainTrigger, GainExecution, LossTrigger, LossExecution, true, model.bypasssuitability, model.clordlinkid, signature)
                .subscribe(res2 => {
                  if (res2.code === 1) {
                    this.callAlert('', Constants.BILLET_ORDER_SEND_01, Constants.ALERT_TYPE.warn);
                  }
                  if (sendTermSuitability && model.bypasssuitability &&
                    ((this.configService.isLoginTypeWSO2() && !validSuitabilityOms) || loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
                    this.authServer.iSuitabilityService.postAssignBounds(model.account, model.quote, client_id, user_id,
                      model.market, model.security_type)
                      .subscribe(res3 => {
                        if (res3) {
                          this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
                        }
                      }, () => {
                        this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
                      });
                  }
                }, () => {
                  this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
                });
            } else {
              this.callAlert('', Constants.BILLET_ORDER_SEND_01, Constants.ALERT_TYPE.warn);
              if (sendTermSuitability && model.bypasssuitability &&
                ((this.configService.isLoginTypeWSO2() && !validSuitabilityOms) || loginTypeEnable === Constants.LOGIN_TYPE.LoginA)) {
                this.authServer.iSuitabilityService.postAssignBounds(model.account, model.quote, client_id, user_id, model.market, model.security_type)
                  .subscribe(res3 => {
                    if (res3) {
                      this.callAlert('', Constants.ORDER_HISTORY_MSG004, Constants.ALERT_TYPE.success);
                      model.bypasssuitability = false;
                    }
                  }, () => {
                    this.callAlert('', Constants.ORDER_HISTORY_MSG005, Constants.ALERT_TYPE.error);
                  });
              }
            }
            if (!isOrderStopSimultaneous) {
              this.sendOrderSingle(model, isOrderStopSimultaneous, client_id, user_id, priceTemp, TypeOrderEnum.LIMITED, signature);
            } else {
              this._showHiddenPadOrderConfirmation.next(true);
            }
          } else {
            if (res.code === 23) {
            } else {
              this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
            }
          }
          this._showHiddenPadOrderConfirmation.next(true);
        }, () => {
          this.callAlert('', Constants.BILLET_ORDER_SEND_03, Constants.ALERT_TYPE.error);
          this._showHiddenPadOrderConfirmation.next(true);
        });
    }
  }

  sendEditAllOrder(quote: string, side: SideEnum, priceOld, priceNew, tickSize: number) {
    if (this.tempOrders && this.tempOrders.length > 0) {
      const openStatus = Constants.ORDER_SEND_OPEN_EDIT_STATUS;
      let noOrdersEdit = true;
      let showSendEditNotification = true;
      tickSize = tickSize < 0 ? 2 : tickSize;
      this.tempOrders.forEach(element => {
        const sideTemp = element.side.toUpperCase() === 'COMPRA' ? SideEnum.BUY : SideEnum.SELL;
        if (openStatus.includes(element.stateCode) && element.quote.toUpperCase() === quote.toUpperCase() && sideTemp === side) {
          const elementTemp = this.convertDailyOrderToSendOrder(element);
          const priceTemp = elementTemp.type === TypeOrderEnum.STOP ? elementTemp.stoptrigger : elementTemp.price;
          const elementPricetemp = this.removeSuffixPriceNumber(priceTemp, elementTemp.market);
          priceOld = this.removeSuffixPriceNumber(priceOld, elementTemp.market);
          if (elementPricetemp === priceOld) {
            priceNew = this.removeSuffixPriceNumber(priceNew, elementTemp.market).toFixed(tickSize);
            if (elementTemp.type === TypeOrderEnum.STOP) {
              elementTemp.stoptrigger = priceNew;
              elementTemp.price = (this.removeSuffixPriceNumber(elementTemp.price, elementTemp.market) + (priceNew - priceOld)).toFixed(tickSize);
            } else {
              elementTemp.price = priceNew;
            }
            noOrdersEdit = false;
            if (showSendEditNotification) {
              this.callAlert('', Constants.BILLET_ORDER_SEND_12, Constants.ALERT_TYPE.info);
              showSendEditNotification = false;
            }
            this.verifyEletronicSignature(TypeOrderRequestEnum.EDIT_ORDER, elementTemp);
          }
        }
      });
      if (noOrdersEdit) {
        this.callAlert('', Constants.ORDER_HISTORY_MSG014.replace('[QUOTE]', quote.toUpperCase()), Constants.ALERT_TYPE.error);
      }
    }
  }

}
